import React from 'react';
import { useNavigate } from 'react-router-dom';
import { about } from '../data/pages';
import { team } from '../data/team';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import Avatar from '../components/Avatar';
import MissionVision from '../components/MissionVision';
import CTA from '../sections/CTA';

export default function About() {
  const navigate = useNavigate();
  const toTeam = () => document.getElementById('team').scrollIntoView({ behavior: 'smooth', block: 'start' });
  return (
    <>
      <PageHero
        title={about.hero.title}
        text={about.hero.text}
        primary={{ label: 'Meet Our Team', onClick: toTeam }}
        secondary={{ label: 'Browse Our Works', onClick: () => navigate('/portfolio') }}
      />

      <section className="section">
        <div className="container">
          <Reveal><h2 className="bigh">Who We Are</h2></Reveal>
          <Reveal delay={80} className="prose prose--wide">
            {about.who.map((p) => <p key={p}>{p}</p>)}
          </Reveal>
          <MissionVision />
        </div>
      </section>

      <section className="section">
        <div className="container">
          <Reveal><h2 className="bigh">Our Values</h2></Reveal>
          <Reveal delay={60} className="prose prose--wide"><p>What guides the way we work with clients and with each other.</p></Reveal>
          <div className="values">
            {about.values.map((v, i) => (
              <Reveal key={v.title} delay={i * 60} className="values__item">
                <h3>{v.title}</h3>
                <p>{v.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <Reveal><h2 className="bigh">Our Journey</h2></Reveal>
          <Reveal delay={60} className="prose prose--wide"><p>Key milestones in our story.</p></Reveal>
          <ol className="journey">
            {about.journey.map((j, i) => (
              <Reveal as="li" key={j.title} delay={(i % 3) * 80} className="journey__card">
                <span className="journey__year">{j.year}</span>
                <h3>{j.title}</h3>
                <p>{j.text}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </section>

      <section id="team" className="section">
        <div className="container">
          <Reveal><h2 className="bigh">{team.title}</h2></Reveal>
          <Reveal delay={60} className="prose prose--wide"><p>{team.text}</p></Reveal>
          <div className="team">
            {team.members.map((m, i) => (
              <Reveal key={m.role} delay={(i % 3) * 80}>
                <article className="tcard">
                  <div className="tcard__photo"><Avatar src={m.photo} name={`${m.name}, ${m.role}`} seed={i} /></div>
                  <h3>{m.name}</h3>
                  <span className="tcard__role">{m.role}</span>
                  <p>{m.bio}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTA />
    </>
  );
}
